<template>
  <div class="adminComp">
    <nav-local-comp :all="'Администраторы'" :id="id" :toAll="toAll"/>
    <admin-crud-comp/>
  </div>
</template>

<script>
export default {
  name: 'adminComp',
  props: {},
  data: function () {
    return {
      moduleName: 'admins',
      required: ['id', 'login']
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
}

@media screen and (max-width: 320px) {
}
</style>
